// pages/FormViewerPage/components/ClaimAddressBox.tsx — kotak isi alamat klaim ongkir (split dari HerbalShippingClaimCard.tsx)
import React from 'react';
import type { AddressData } from '../../../components/AddressInput';

interface ClaimAddressBoxProps {
    promoTitleShort: string;
    currentDetailAddress: string;
    onAddressChange: (data: AddressData | ((prev: AddressData) => AddressData)) => void;
    fieldErrors?: Record<string, string>;
}

export const ClaimAddressBox: React.FC<ClaimAddressBoxProps> = ({ promoTitleShort, currentDetailAddress, onAddressChange, fieldErrors }) => (
    <div className="mt-2 p-3 bg-emerald-50/60 dark:bg-emerald-950/30 border border-emerald-400 dark:border-emerald-700 rounded-xl space-y-2 animate-fadeIn">
        <div className="flex items-center justify-between">
            <label htmlFor="herbal-address" className="text-xs font-bold text-slate-900 dark:text-white flex items-center gap-1.5">
                <span>🏡 Alamat Rumah Lengkap:</span>
                <span className="text-red-500">*</span>
            </label>
            <span className="text-[10px] font-bold text-emerald-700 dark:text-emerald-300 bg-emerald-100 dark:bg-emerald-900/50 px-2 py-0.5 rounded-full">
                {promoTitleShort} Aktif ✓
            </span>
        </div>
        <textarea
            id="herbal-address"
            rows={2}
            value={currentDetailAddress}
            onChange={(e) => {
                const val = e.target.value;
                onAddressChange(prev => ({
                    ...prev,
                    detailAddress: val,
                    fullAddress: val,
                }));
            }}
            placeholder="Tulis Jalan / No. Rumah, RT/RW, Dusun/Desa, Kecamatan, Kota/Kabupaten..."
            className={`w-full p-2.5 text-xs sm:text-sm border rounded-lg bg-white dark:bg-slate-800 text-slate-900 dark:text-slate-100 focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 transition leading-relaxed placeholder:text-slate-500 ${
                fieldErrors?.address ? 'border-red-500' : 'border-slate-400 dark:border-slate-500'
            }`}
        />
        {fieldErrors?.address ? (
            <p className="text-[11px] text-red-600 dark:text-red-400 font-medium">
                ⚠️ {fieldErrors.address}
            </p>
        ) : (
            <p className="text-[10px] text-emerald-700 dark:text-emerald-300 flex items-center gap-1">
                <span>✅</span>
                <span>Potongan ongkir langsung dipakai di pesanan Anda — tanpa ini ongkir tetap penuh</span>
            </p>
        )}
    </div>
);
